/* istanbul ignore file */

import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  HEADLINE: () => FORM_FIELDS.HEADLINE,
  STANDFIRST: () => FORM_FIELDS.STANDFIRST,
  LANGUAGE: () => FORM_FIELDS.LANGUAGE,
  CONTENT_BODY: () => FORM_FIELDS.CONTENT_BODY,
  BODY: () => `${FORM_FIELDS.CONTENT_BODY}.${FORM_FIELDS.BODY}`,
  IMGS: () => `${FORM_FIELDS.CONTENT_BODY}.${FORM_FIELDS.IMGS}`,
  VIDEOS: () => `${FORM_FIELDS.CONTENT_BODY}.${FORM_FIELDS.VIDEOS}`,
  WEBSITES: () => FORM_FIELDS.WEBSITES,
  INTERNAL_INFORMATION: () => FORM_FIELDS.INTERNAL_INFORMATION,
  LIVE_URLS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.LIVE_URLS}`,
  CONTENT_IDS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.CONTENT_IDS}`,
  ARTICLE_VERSION_LIST: () => FORM_FIELDS.ARTICLE_VERSION_LIST,
  NEXT_STATES: () => FORM_FIELDS.NEXT_STATES,
  PUBLISH_TIME: () => `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.DATE}`,
  TIMEZONE: () => `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.TIMEZONE}`,
  SHOW_PUBLISH_TIME: () =>
    `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.SHOW_PUBLISH_TIME}`,
  CONTENT_LISTS: () => FORM_FIELDS.CONTENT_LISTS,
  SELECTED_AUTHORS: () => FORM_FIELDS.SELECTED_AUTHORS,
  SELECTED_SPONSOR: () =>
    `${FORM_FIELDS.SPONSORS}.${FORM_FIELDS.SELECTED_SPONSOR}`,
  IS_SPONSORED: () => `${FORM_FIELDS.SPONSORS}.${FORM_FIELDS.IS_SPONSORED}`,
  COLUMNIST_CONTENT: () => FORM_FIELDS.COLUMNIST_CONTENT,
  RELATED_MANAGERS: () => FORM_FIELDS.RELATED_MANAGERS,
  RELATED_FUNDS: () => FORM_FIELDS.RELATED_FUNDS,
  RELATED_SECTORS: () => FORM_FIELDS.RELATED_SECTORS,
  RELATED_ASSET_CLASSES: () => FORM_FIELDS.RELATED_ASSET_CLASSES,
  RELATED_ETFS: () => FORM_FIELDS.RELATED_ETFS,
  RELATED_INVESTMENT_TRUSTS: () => FORM_FIELDS.RELATED_INVESTMENT_TRUSTS,
  RELATED_SHARES: () => FORM_FIELDS.RELATED_SHARES,
  RELATED_PRIVATE_MARKETS_FUNDS: () => FORM_FIELDS.RELATED_PRIVATE_MARKETS_FUNDS,
  RELATED_ARTICLES: () => FORM_FIELDS.RELATED_ARTICLES,
  EXTERNAL_LINKS: () => FORM_FIELDS.EXTERNAL_LINKS,
  SURTITLES: () => FORM_FIELDS.SURTITLES,
  EDITION_LANGUAGE: () => FORM_FIELDS.EDITION_LANGUAGE,
  TYPED_TAGS: () => FORM_FIELDS.TYPED_TAGS,
  TAGS: () => FORM_FIELDS.TAGS,
  TOPICS: () => FORM_FIELDS.TOPICS,
  TOPICS_WITH_TRANSLATIONS: () => FORM_FIELDS.TOPICS_WITH_TRANSLATIONS,
  COMPANIES: () => FORM_FIELDS.COMPANIES,
  PEOPLE: () => FORM_FIELDS.PEOPLE,
  RESTRICTED_TO_REGISTERED_USERS: () =>
    FORM_FIELDS.RESTRICTED_TO_REGISTERED_USERS,
  NOT_FOR_GOOGLE_NEWS_SITEMAPS: () => FORM_FIELDS.NOT_FOR_GOOGLE_NEWS_SITEMAPS,
  NOT_FOR_NEWS_FEED: () => FORM_FIELDS.NOT_FOR_NEWS_FEED,
  HIDE_THIS_ARTICLE: () => FORM_FIELDS.HIDE_THIS_ARTICLE,
  PAYWALL_PREMIUM_CONTENT: () => FORM_FIELDS.PAYWALL_PREMIUM_CONTENT,
  NOT_FOR_COMPETITORS: () => FORM_FIELDS.NOT_FOR_COMPETITORS,
  MAIN_IMAGE: () => FORM_FIELDS.MAIN_IMAGE,
  MAIN_VIDEO: () => FORM_FIELDS.MAIN_VIDEO,
  DISPLAY_IMAGE_ON_WEBSITE: () => FORM_FIELDS.DISPLAY_IMAGE_ON_WEBSITE,
};
